<template>
    <a href="#" data-toggle="dropdown">
        <img :src="require('../assets/viaerpwhite.png')" width="70" height="70"  style="position:fixed;padding-left:10px;padding-top:0px"/>
    </a>
    <ul class="dropdown-menu list-group;" style="padding:0;color: white;">
        <li class="list-group-item" v-if="hasPermission(1)" style="background-color: #656565;border: solid 2px;border-style: outset; outset;text-align:left"><a style="color:whitesmoke;" onmouseover="this.style.backgroundColor='#656565'" href="#" @click="handleMainPage">Main Page</a></li>
        <li class="list-group-item" v-if="hasPermission(20)" style="background-color: #656565;border: solid 2px;border-style: outset; outset;text-align:left"><a style="color:whitesmoke"  onmouseover="this.style.backgroundColor='#656565'" href="#" @click="handleAddCustomer">Customers</a></li>
        <li class="list-group-item" v-if="hasPermission(26)" style="background-color: #656565;border: solid 2px;border-style: outset;text-align:left"><a style="color:whitesmoke"  onmouseover="this.style.backgroundColor='#656565'" href="#" @click="handleFindInvoice">Find invoice</a></li>
        <!-- <li class="list-group-item" v-if="hasPermission(31)" style="background-color: #656565;border: solid 2px;border-style: outset;text-align:left"><a style="color:whitesmoke"  onmouseover="this.style.backgroundColor='#656565'" href="#" @click="handleProductReturn">Return Invoice</a></li> -->
        <li class="list-group-item" v-if="hasPermission(32)" v-show="reports_ok" style="text-align:left; background-color: #656565;border: solid 2px;border-style: outset; outset;"><a  style="color:whitesmoke;" onmouseover="this.style.backgroundColor='#656565'" href="#" @click="handleReports">Reports</a></li>
        <li class="list-group-item" style="background-color: #fe4435;border: solid 2px;border-style: outset;text-align:left"><a style="color:whitesmoke"  onmouseover="this.style.backgroundColor='#fe4435'" href="#" @click="handleLogout">Logout</a></li>
    </ul>                                          
</template>
<script>
  import commonServices from "@/shared/commonServices"

export default {
    name:"MainMenu",
    mixins: [commonServices],
    mounted() {
      if(localStorage.reports_ok === "1"){
        this.reports_ok = true;
      }     
      if(localStorage.pos_ok === "1"){
        this.pos_ok = true;
      }     
      if(localStorage.pos_ok === "1"){
        this.pos_ok = true;
      }     

      this.language = 'ar';
      this.handleLanguage();
     
    },    
    data: function(){
        return {
            jsonData  : {},
            reports_ok : "0",
        }
    },
    methods:{
      handleReports() {
      this.$router.push({ name: 'reports'} );
    },

  handleMainPage() {
      this.$router.push({ name: 'main'} );
    },


  handleDailyTotals() {
      this.$router.push({ name: 'dailytotal'} );
    },

  handleDailySales() {
      this.$router.push({ name: 'dailysales'} );
    },

  handleItemsDaily() {
      this.$router.push({ name: 'itemsdaily'} );
    },

   goLogin()
    {
      this.$router.push({ name: 'login' });
    },
   handleFindInvoice()
    {
      this.$router.push({ name: 'find' });
    },
    handleAddCustomer(){
        this.$router.push({ name: 'customers'});
    },   
    

    }

};
</script>